import { useAnalytics } from '../../AnalyticsProvider/AnalyticsProvider';
import { TLikesSectionPosition, TLikeDestination } from '../types';
import { ArticleType } from '../../Article/types';

export const useLikesAnalyticsEvents = () => {
  const { sendEvent } = useAnalytics();

  const sendLikeButtonClickEvent = ({
    relatedItemId,
    relatedItemType,
    destination,
    position,
    value,
  }: {
    relatedItemId: string;
    relatedItemType: ArticleType;
    destination: TLikeDestination;
    position: TLikesSectionPosition;
    value: boolean;
  }) => {
    sendEvent('like_button_click', {
      related_item_type: relatedItemType,
      related_item_id: relatedItemId,
      like_destination: destination,
      position,
      value,
    });
  };

  const sendLikeCounterClickEvent = ({
    relatedItemId,
    relatedItemType,
    position,
  }: {
    relatedItemId: string;
    relatedItemType: ArticleType;
    position: TLikesSectionPosition;
  }) => {
    sendEvent('like_counter_click', { position, related_item_id: relatedItemId, related_item_type: relatedItemType });
  };

  return { sendLikeButtonClickEvent, sendLikeCounterClickEvent };
};
